<template lang="pug">
form.image-upload(ref='form')
  .image-upload-wrap
    v-text-field(
      :label='label',
      v-model='name',
      prepend-icon='attach_file',
      :hint='hint',
      persistent-hint
    )
    //- Триггер выбора файла
    input(@change='readFile', accept='image/*', type='file', ref='image')
  //- Контейнер для изображения
  v-card.image-upload-preview.mt-4(v-if='image')
    v-img.grey.lighten-4(
      :style='{ opacity: preview ? 0 : 1 }',
      :aspect-ratio='imgRatio',
      :lazy-src='image',
      :src='image'
    )
      v-layout(
        slot='placeholder',
        fill-height,
        align-center,
        justify-center,
        ma-0
      )
        v-progress-circular(indeterminate, color='primary')
    .controls
      v-spacer
      //- Кнопка триггерит событие вызова редактора
      v-tooltip(v-if='editor', top)
        v-btn(@click.stop='$emit("editor")', slot='activator', icon)
          v-icon format_shapes
        | Редактор планировки
      //- Кнопка триггерит событие переключения режима превью/не превью
      v-tooltip(v-if='scheme', top)
        v-btn(@click.stop='preview = !preview', slot='activator', icon)
          v-icon {{ preview ? "visibility_off" : "visibility" }}
        | {{ preview ? "Скрыть планировку" : "Показать планировку" }}
      //- Кнопка триггерит открытие ссылки на картинику
      v-tooltip(v-if='image', top)
        v-btn(@click.stop='openUrl', slot='activator', icon)
          v-icon image
        | Открыть ссылку
      //- Кнопка триггерит событие удаления изображения
      v-tooltip(top)
        v-btn(@click.stop='remove', slot='activator', icon)
          v-icon delete_outline
        | Удалить
    //- Доп слот для кастомных превьюшек, например SVG
    .extension(v-if='preview', @click.stop)
      slot(name='extension')
  v-dialog(v-model='busy', persistent, width='280')
    v-card(color='primary', dark)
      v-card-text Загрузка файла
      v-progress-linear.mb-0(v-model='progress', color='white')
</template>

<script>
import http from '@/http'

export default {
  props: {
    label: {
      type: String,
      default: 'Выберите файл для загрузки',
    },
    hint: {
      type: String,
      default: 'Допустимые форматы: jpg, png, gif, svg',
    },
    src: String,
    editor: Boolean,
    scheme: Boolean,
    parseResponse: {
      type: Function,
      default: (v) => v,
    },
    ratio: {
      default: 1 / 1,
    },
    recordId: {
      type: Number,
      default: null,
    },
    hasPreview: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    name: null,
    image: null,
    preview: false,
    busy: false,
    hash: null,
    progress: 0,
  }),

  created() {
    this.image = this.src
    this.preview = this.hasPreview
  },

  methods: {
    async upload(file) {
      if (this.busy) return
      this.busy = true

      let formdata = new FormData()
      let extension = file.name.split('.').pop()
      formdata.append('attachFile', file, `attach.${extension}`)

      try {
        let response = await http.post('/files/upload', formdata, {
          onUploadProgress: (progressEvent) => {
            let totalLength = progressEvent.lengthComputable
              ? progressEvent.total
              : progressEvent.target.getResponseHeader('content-length') ||
                progressEvent.target.getResponseHeader(
                  'x-decompressed-content-length'
                )
            if (totalLength !== null) {
              let progress = Math.round(
                (progressEvent.loaded * 100) / totalLength
              )
              this.progress = progress
              this.$emit('upload-progress', progress)
            }
          },
        })
        this.$emit('input', this.parseResponse(response.data))
        this.$emit('upload-success', response.data)
      } catch (error) {
        this.$emit('upload-error', error)
      }

      this.busy = false
    },

    async remove() {
      if (this.busy || !(await this.$confirm('Удалить изображение?'))) return

      this.busy = true

      try {
        const hash =
          typeof this.$attrs.value === 'string'
            ? this.$attrs.value
            : this.$attrs.value.hash

        let response = await http.delete(`/files/delete/${hash}`, {
          record_id: this.recordId,
        })

        this.image = null

        this.$emit('input', null)
        this.$emit('remove-success', response)

        this.$nextTick(() => this.$refs.form.reset())
      } catch (error) {
        this.$emit('remove-error', error)
      }

      this.busy = false
    },

    openUrl() {
      if (!this.image) return
      window.open(this.image, '_blank')
    },

    readFile(event) {
      let imageType = /image.*/
      let file = event.target.files[0]

      if (file && file.type.match(imageType)) {
        this.name = file.name

        this.$refs.form.reset()
        let reader = new FileReader()

        reader.onload = () => {
          this.image = reader.result
        }

        reader.readAsDataURL(file)
        this.upload(file)
      } else {
        this.$root.showSnack('Неподдерживаемый формат файла')
      }
    },
  },

  watch: {
    src(val) {
      this.image = val
    },
    hasPreview(val) {
      this.preview = val
    },
  },

  computed: {
    imgRatio() {
      if ('auto' === this.ratio + '') return
      return this.ratio
    },
  },
}
</script>

<style scoped>
.image-upload-wrap {
  overflow: hidden;
  position: relative;
}
.image-upload [type='file'] {
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 50px;
  position: absolute;
}
.image-upload-preview {
  padding-bottom: 48px;
  overflow: hidden;
  pointer-events: none;
}
.controls {
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2;
  position: absolute !important;
  background: white;
  display: flex;
  align-items: flex-end;
  pointer-events: auto;
}
.extension {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
}
</style>
